import { z } from 'zod';

export const NewConditionSchema = z
  .object({
    condition_id: z.string().optional(),
    custom_condition_name: z.string().optional(),
    severity: z.string(),
    diagnosed_date: z.string().optional(),
    status: z.string(),
    notes: z.string().optional()
  })
  .refine(
    data => Boolean(data.condition_id || data.custom_condition_name),
    {
      message: 'Either condition_id or custom_condition_name is required',
      path: ['condition_id']
    }
  );

export type NewCondition = z.infer<typeof NewConditionSchema>;

export interface ConditionEntry extends NewCondition {
  id: string;
  user_id: string;
  created_at: string;
  updated_at: string;
  medical_conditions_db?: Record<string, unknown>;
}

export const NewSymptomSchema = z.object({
  name: z.string(),
  category: z.string(),
  severity: z.number().int().min(0).max(10),
  notes: z.string().optional(),
  triggers: z.array(z.string()).optional(),
  related_conditions: z.array(z.string()).optional(),
  ai_suggested: z.boolean().optional()
});
export type NewSymptom = z.infer<typeof NewSymptomSchema>;
export interface SymptomEntry extends NewSymptom {
  id: string;
  user_id: string;
  recorded_at: string;
  created_at: string;
}

export const NewMedicationSchema = z.object({
  name: z.string(),
  dosage: z.string(),
  frequency: z.string(),
  instructions: z.string(),
  start_date: z.string(),
  end_date: z.string().optional(),
  is_active: z.boolean().optional(),
  adherence_percentage: z.number().int().optional()
});
export type NewMedication = z.infer<typeof NewMedicationSchema>;
export interface MedicationEntry extends NewMedication {
  id: string;
  user_id: string;
  created_at: string;
  updated_at: string;
}

export const NewFoodEntrySchema = z.object({
  meal_type: z.string(),
  food_name: z.string(),
  brand: z.string().nullable().optional(),
  serving_size: z.number().positive(),
  serving_unit: z.string(),
  macros: z.object({
    calories: z.number().min(0),
    carbs: z.number().min(0),
    protein: z.number().min(0),
    fat: z.number().min(0),
    fiber: z.number().min(0)
  }),
  logged_at: z.string()
});
export type NewFoodEntry = z.infer<typeof NewFoodEntrySchema>;
export interface FoodEntry extends NewFoodEntry {
  id: string;
  user_id: string;
  created_at: string;
}

export const NewDeviceMetricSchema = z.object({
  device_id: z.string(),
  metric_name: z.string(),
  metric_value: z.number(),
  metric_unit: z.string(),
  recorded_at: z.string()
});
export type NewDeviceMetric = z.infer<typeof NewDeviceMetricSchema>;
export interface DeviceMetric extends NewDeviceMetric {
  id: string;
  user_id: string;
  created_at: string;
}

